// 日志管理
export default [
  {
    path: "/logs",
    meta: { title: "日志管理" },
    component: () => import("../views/logs/index"),
    children: [
      {
        path: "/logs/operlog",
        name: "operlog",
        meta: { title: "操作日志", isMenu: true },
        component: () => import("../views/logs/operlog.vue"),
      },
      {
        path: "/logs/loginlog",
        name: "loginlog",
        meta: { title: "登录日志", isMenu: true },
        component: () => import("../views/logs/loginlog.vue"),
      },
    ],
  },
]
